import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconChartBarOff } from '@tabler/icons-react';

interface EmptyStateProps {
  message?: string;
  className?: string;
}

export default function EmptyState ({
  message,
  className = '',
}: EmptyStateProps): React.JSX.Element {
  const { t } = useTranslation();
  const displayMessage = message ?? t('dashboard.overview.emptyDefault');

  return (
    <div className={`flex flex-col items-center justify-center py-10 text-muted-foreground ${className}`}>
      <IconChartBarOff size={32} className="mb-2 opacity-40" />
      <p className="text-sm">{displayMessage}</p>
    </div>
  );
}
